import {gql} from 'apollo-angular';

export const GET_COMPANY_BENEFITS = gql`
  query GetCompanyBenefits {
    getCompanyBenefits {
      id
      name
    }
  }
`;
